// @ts-nocheck
import globalStyle from "@store/Themes/common/styleguide/globalStyle";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";

export default mergeProps(globalStyle, {});
